<template>
  <van-tabbar id="tabbar-global" v-model="active" route  :active-color="mainColor"
              inactive-color="#333333" :z-index="9999999999999">
    <van-tabbar-item
        replace
        v-for="(item,index) in tabbar"
        :key="index"
        :to="item.urlType==='0'?item.url:''"
        :url="item.urlType==='1'?complete(item.url):''"
    >
      <van-icon v-if="isLocal" class="iconfont tabbar-item-icon" class-prefix="icon" :name="item.icon"/>
      <img v-else :src="complete(item.icon)" class="tabbar-item-icon" onload="SVGInject(this)"/>
      <span class="tabbar-item-text">{{ item.configName}}</span>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>

import {getThemeParams} from "@/utils/theme";
import {fetchRgbColer} from "@/utils/commons";
import {globalTabbar} from "@/api";
import {complete} from "@/utils/url";
import * as svg from '@/utils/svg-inject.min'

export default {
  name: "Tabbar",
  computed: {
    mainColor() {
      if (getThemeParams('main_color')){
        return getThemeParams('main_color');
      } else {
        return '#003c88'
      }
    },
    mainColorLight() {
      let rgb = fetchRgbColer(this.mainColor)
      return 'rgba(' + rgb.join(',') + ',0.08)'
    }
  },
  created() {
    this.getTabbar();
  },
  data() {
    return {
      active: 0,
      tabbar: [],
      defaultTabbar: [
        {
          configName: '首页',
          icon: 'homepage',
          url: '/home',
          urlType: 0,
          notLoginSelectedConfig: undefined,
          loginedSelectedConfig: undefined,
          mastLoginConfig: undefined
        },
        {
          configName: '办事',
          icon: 'order',
          url: '/homeTab/serviceHall',
          urlType: 0,
          notLoginSelectedConfig: undefined,
          loginedSelectedConfig: undefined,
          mastLoginConfig: undefined
        },
        {
          configName: '效能',
          icon: 'dynamic',
          url: '/efficacy',
          urlType: 0,
          notLoginSelectedConfig: undefined,
          loginedSelectedConfig: undefined,
          mastLoginConfig: undefined
        },
        {
          configName: '清单',
          icon: 'createtask',
          url: '/threeList',
          urlType: 0,
          notLoginSelectedConfig: undefined,
          loginedSelectedConfig: undefined,
          mastLoginConfig: undefined
        },
        {
          configName: '我的',
          icon: 'people',
          url: '/mine',
          urlType: 0,
          notLoginSelectedConfig: undefined,
          loginedSelectedConfig: undefined,
          mastLoginConfig: undefined
        }
      ],
      isLocal:false
    }
  },
  methods: {
    getTabbar() {
      // 尝试从缓存获取
      const storage = sessionStorage.getItem("global-tabbar");
      const params = storage !== "undefined" && storage !== "" ? JSON.parse(storage) : null;
      if (params) {
        this.tabbar = params;
      }
      globalTabbar().then(resp => {
        if (!resp || resp.code != 200 || !resp.data){
          this.tabbar = this.defaultTabbar;
          this.isLocal = true;
        }
        if (resp.data) {
          var data = resp.data.slice(0,5)
          sessionStorage.setItem("global-tabbar", JSON.stringify(data))
          this.tabbar = data;
        }
      })
    },
    complete
  }
}
</script>

<style lang="scss">
@import "~@/assets/css/theme/theme.scss";
#tabbar-global {
  &.van-tabbar {
    height: 50px;
  }

  //.van-tabbar-item__icon{
  //  display: none;
  //}
  .van-tabbar-item__text {
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    text-align: center;
    justify-content: center;
    font-size: 13px;
  }

  .tabbar-item-text {
    color: inherit;
    font-size: inherit;
  }

  .tabbar-item-icon {
    color: inherit;
    font-size: 24px;
    width:20px;
    height:20px;

  }
  svg.tabbar-item-icon{
    width:24px;
    height:24px;
    fill:#333333;
  }
  .van-tabbar-item--active{
    svg.tabbar-item-icon{
      fill:var(--main-color);
    }
    .tabbar-item-text {
      color: var(--main-color);
    }
  }
}

</style>
